import { MapContainer, TileLayer, Marker, Circle } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";



const createIcon = (color) => new L.divIcon({
    className: 'custom-div-icon',
    html: `<div 
    style='background-color:${color}; 
    width: 14px; height: 14px; 
    border-radius: 50%; border: 2px solid white; 
    box-shadow: 0 0 4px rgba(0,0,0,0.5);'>
    
    </div>`,
    iconSize: [14, 14],
    iconAnchor: [7, 7]
});

const busIcon = createIcon('#3bf689')
const metroIcon = createIcon('#3b82f6'); // Azul
const tremIcon = createIcon('#ef4444'); // Vermelho
const terminalIcon = createIcon('#f59e0b'); // Laranja

export default function MapaOnibus({ pontosOnibus, estacoesMetro, estacoesTrem, terminaisOnibus, centro, bbox }) {

    const bounds = bbox ? [
        [bbox.lat_min, bbox.lng_min], // sudoeste
        [bbox.lat_max, bbox.lng_max], // nordeste
    ] : undefined;

    return (
        <MapContainer
            center={centro}
            zoom={13}
            style={{ height: "500px", width: "100%", marginTop: 20 }}
        >
            <TileLayer
                attribution='&copy; OpenStreetMap'
                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
            />

            {pontosOnibus && pontosOnibus.map((ponto, index) => (
                <Marker key={`bus-${index}`} position={[ponto.lat, ponto.lng]} icon={busIcon} />
            ))}

            {estacoesMetro && estacoesMetro.map((ponto, index) => (
                <Marker key={`metro-${index}`} position={[ponto.lat, ponto.lng]} icon={metroIcon} />
            ))}

            {estacoesTrem && estacoesTrem.map((ponto, index) => (
                <Marker key={`trem-${index}`} position={[ponto.lat, ponto.lng]} icon={tremIcon} />
            ))}

            {terminaisOnibus && terminaisOnibus.map((ponto, index) => (
                <Marker key={`term-${index}`} position={[ponto.lat, ponto.lng]} icon={terminalIcon} />
            ))}

            {/* Raio de Ônibus (1km) */}
            <Circle center={centro} radius={1000} pathOptions={{ color: '#22c55e', fillOpacity: 0.1, weight: 1 }} />

            {/* Raio de Metrô (3km) */}
            <Circle center={centro} radius={3000} pathOptions={{ color: '#3b82f6', fillOpacity: 0.05, weight: 1 }} />

            {/* Raio de Trem e Terminais (5km) */}
            <Circle center={centro} radius={5000} pathOptions={{ color: '#ef4444', fillOpacity: 0.05, weight: 1 }} />
        </MapContainer>
    );
}